import { COLOURS } from '@shootsta/common-react';

const { white, russian, michael, denim, regent, nevada, parthenon } = {
  white: COLOURS.mono.white,
  russian: COLOURS.grey.mischka.russian,
  michael: COLOURS.grey.mischka.michael,
  denim: COLOURS.grey.denim,
  regent: COLOURS.grey.regent,
  nevada: COLOURS.grey.nevada,
  parthenon: COLOURS.grey.athens.parthenon
};

export const customSelectStyles = {
  container: (provided: any) => ({
    ...provided,
    minWidth: '110px',
    height: '24px'
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    borderRadius: '100px',
    border: `1px solid ${russian}`,
    backgroundColor: white,
    minHeight: '24px',
    height: '24px',
    padding: '0 10px',
    fontSize: '12px',
    fontFamily: '"Poppins", "Inter", "Helvetica Neue", Arial, sans-serif',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    boxShadow: state.isFocused ? `0 0 0 1px ${michael}` : 'none',
    cursor: 'pointer'
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: 0,
    paddingLeft: '0 !important',
    marginTop: '3px',
    display: 'flex',
    alignItems: 'center',
    height: '24px'
  }),
  singleValue: (provided: any) => ({
    ...provided,
    fontSize: '12px',
    fontFamily: '"Poppins", "Inter", sans-serif',
    fontWeight: 400,
    lineHeight: '16px',
    color: '#374151',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  }),
  placeholder: (provided: any) => ({
    ...provided,
    fontSize: '12px',
    fontFamily: '"Poppins", "Inter", sans-serif',
    fontWeight: 400,
    lineHeight: '16px',
    color: '#9CA3AF',
    display: 'flex',
    alignItems: 'center',
    top: '35%'
  }),
  input: (provided: any) => ({
    ...provided,
    margin: 0,
    padding: 0
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    svg: {
      width: '12px',
      height: '12px',
      stroke: nevada
    }
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  }),
  menu: (provided: any) => ({
    ...provided,
    marginTop: '4px',
    borderRadius: '8px',
    border: `1px solid ${russian}`,
    backgroundColor: white,
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    minWidth: '160px'
  }),
  menuList: (provided: any) => ({
    ...provided,
    padding: '4px 0',
    fontSize: '12px'
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontFamily: '"Poppins", "Inter", sans-serif',
    fontWeight: 400,
    padding: '6px 10px',
    fontSize: '12px !important',
    color: nevada,
    whiteSpace: 'nowrap',
    backgroundColor: state.isFocused ? parthenon : white,
    cursor: 'pointer'
  })
};
